import React, {
    useState,
    Suspense,
    lazy
} from 'react';
import {
    useDispatch, useSelector } from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import { 
    Card,
    Image,
    Text,
    Group,
    Badge,
    createStyles,
    Center,
    Button,
    ActionIcon,
    Grid
} from '@mantine/core';
import {
    IconGavel,
    IconPencil,
    IconEye,
    IconCalendar,
    IconUsers
} from '@tabler/icons';
import { ResponsiveCarouselCard } from './ResponsiveCarouselCard';
const useStyles = createStyles((theme) => ({
    cardContain: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,    
        width: '95%',
        margin: '0 auto',
        maxWidth: '800px',
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /*borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,*/
    },
    
    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        letterSpacing: -0.25,
        textTransform: 'uppercase',
    },

    section: {
        padding: theme.spacing.md,
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },
    subSection: {
        borderBottom: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
        }`,
    },

    icon: {
        marginRight: 5,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
    actionGrid: {
        margin: '0 auto',
        textAlign: 'center',
        contentAlign: 'center',
    },
    editArea: {
        margin: '0 auto'
    }
}));


//needed: params
//needed: rendered via map functionality
export function AuctionItemMgmtItem() {
    const { classes } = useStyles();
    const listItemClick = (interaction) => {
        switch(interaction) {
            case 'edit':
                console.log('value was edit');
                break;
            case 'schedule':
                console.log('value was schedule');
                break;
            case 'preview':
                console.log('value was preview');
                break;
            case 'staff':
                console.log('value was staff');
                break;
            default:
                console.log('could not match a value')
        }
    };

    return (
        <Card withBorder radius="md" className={classes.cardContain}>
            <Card.Section className={classes.imageSection}>
                <ResponsiveCarouselCard />
            </Card.Section>
            
            <Card.Section className={classes.section} mt="md">
                {/*handle state via props and use the state to set the color*/}
                <Badge variant="gradient" gradient={{ from: 'teal', to: 'lime', deg: 105 }}>Active</Badge>
                <Text size="lg" weight={700}>
                2015 Pagani Huayra Mint Condition Barely Used
                </Text>
                <br/>
                <Text size="md" color="dimmed" className={classes.label}>
                Pittsburgh, Pennsylvania
                </Text>
            </Card.Section>

            <Card.Section className={classes.section,classes.subSection}>
                <Group position="apart">
                    <div>
                        <Text size="lg" weight={700} sx={{ lineHeight: 1 }}>
                        Bid $95,000
                        </Text>
                    </div>
                    <Text size="lg" weight={700}>
                    8 Days
                    </Text>
                </Group>
            </Card.Section>

            <Card.Section className={classes.section}>
                <Grid className={classes.actionGrid} gutter={5} gutterXs="md" gutterMd="xl" gutterXl={50}>
                    <Grid.Col span={3}>
                        <ActionIcon className={classes.editArea} onClick={() => {listItemClick('edit')}}>
                            <IconPencil color="black" />
                        </ActionIcon>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <ActionIcon className={classes.editArea}  onClick={() => {listItemClick('schedule')}}>
                            <IconCalendar color="black" />
                        </ActionIcon>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <ActionIcon className={classes.editArea}  onClick={() => {listItemClick('preview')}}>
                            <IconEye color="black"/>
                        </ActionIcon>
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <ActionIcon className={classes.editArea}  onClick={() => {listItemClick('staff')}}>
                            <IconUsers color="black"/>
                        </ActionIcon>
                    </Grid.Col>
                </Grid>
            </Card.Section>
        </Card>
    );
}
